import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "infoBlocks" }
const _hoisted_2 = { class: "infoBlocks__block" }
const _hoisted_3 = { class: "infoBlocks__block__left" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "listInfo" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, " Инициатор: ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, " Агент: ", -1)
const _hoisted_8 = { class: "infoBlocks__block__right" }
const _hoisted_9 = { class: "infoData" }
const _hoisted_10 = /*#__PURE__*/_createVNode("ul", { class: "listInfo" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, "Информация о предложении " + _toDisplayString(_ctx.order.orderId), 1),
        _createVNode("ul", _hoisted_5, [
          _createVNode("li", null, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.initiatorName), 1 /* TEXT */)
          ]),
          _createVNode("li", null, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.agentName), 1 /* TEXT */)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.dataStart) + " ", 1 /* TEXT */),
            (_ctx.dataStart !== _ctx.dataEnd)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" | " + _toDisplayString(_ctx.dataEnd), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", {
            class: "status",
            title: _ctx.order.statusName
          }, _toDisplayString(_ctx.order.statusName), 9, ["title"])
        ]),
        _hoisted_10
      ])
    ])
  ]))
}